// extracted by mini-css-extract-plugin
module.exports = {"root":"YouTubePlayer_root__mlf1J","caption":"YouTubePlayer_caption__mDlkK","player":"YouTubePlayer_player__LmDyY","playButton":"YouTubePlayer_playButton__RoNH0"};